import { useCallback, useEffect } from 'react'
import { useQuery, useReactiveVar } from '@apollo/client'
import { labelCodeIdVar, labelCodeVar, searchNameVar, searchResultVar } from 'modulesCommon/store'
import { SEARCH } from 'modulesCommon/graphql/queries'
import { useLoading, useServerError } from 'shared/hooks'

const useHeaderSearch = () => {
  const searchResult = useReactiveVar(searchResultVar)
  const searchName = useReactiveVar(searchNameVar)
  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const currentLabelCode = useReactiveVar(labelCodeVar)

  const isGlobalHubPage = window.location.pathname.includes('/globalhub')

  const {
    data: searchData,
    error: searchError,
    loading: searchLoading
  } = useQuery(SEARCH, {
    fetchPolicy: 'no-cache',
    skip: !searchName || (!currentLabelId && !isGlobalHubPage),
    variables: { name: searchName, label_id: currentLabelId || '', is_global: isGlobalHubPage }
  })

  const clearSearchResult = useCallback(() => {
    searchResultVar({})
    searchNameVar('')
  }, [])

  const searchHandler = useCallback(
    (name) => {
      if (name && (currentLabelId || isGlobalHubPage)) {
        searchNameVar(name)
      }
    },
    [currentLabelId, isGlobalHubPage]
  )

  useEffect(() => {
    if (searchData) searchResultVar(searchData.search)
  }, [searchData])

  useLoading({ isLoading: searchLoading })
  useServerError([searchError])

  return {
    searchHandler,
    searchResult,
    clearSearchResult,
    isGlobalHubPage,
    currentLabelCode,
    searchLoading
  }
}

export default useHeaderSearch
